<template>
  <div
    class="soha-add-new-item"
    @click="addNewItem"
  >
    <span :class="`mr-2 svg-icon svg-icon-md svg-icon-${color} `">
      <inline-svg :src="`/media/svg/soha/icons/${icon}.svg`" />
    </span>
    <span :class="`${color}-color`"> {{ text }} </span>
  </div>
</template>

<script>
import "@/assets/css/components/base/add-new-item.css";

export default {
  emits: ['addNewItem'],

  name: "AddNewItem",

  props: {
    color: {
      default: "primary",
      type: String,
    },
    icon: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
  },
  methods: {
    addNewItem() {
      this.$emit("addNewItem");
    },
  },
};
</script>
